import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

let abortControllerFetchUsers = null;

export const fetchUsersAdmin = createAsyncThunk(
  'get/users/v3/users',
  async ({ offset, limit, kw }, { dispatch }) => {
    try {
      if (abortControllerFetchUsers) {
        abortControllerFetchUsers.abort();
      }
      abortControllerFetchUsers = new AbortController();
      const res = await callApi({
        endpoint: 'users/v3/users',
        method: 'get',
        params: {
          offset,
          limit,
          keyword: kw,
        },
        signal: abortControllerFetchUsers.signal,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response?.result?.data,
          total: response?.count ?? 0,
          next: response?.next_page,
          previous: response?.previous,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const fetchDetailedUserAdmin = createAsyncThunk(
  'get/users/v3/customer/detail',
  async (id, { dispatch }) => {
    try {
      abortControllerFetchUsers = new AbortController();
      const res = await callApi({
        endpoint: 'users/v3/customer/detail/' + id,
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response?.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
